import { useTenantThemeRuntime } from "./runtime-context.ts";

export function useThemePreset() {
  return useTenantThemeRuntime().definition;
}

export function useThemeResources() {
  return useTenantThemeRuntime().resources;
}

export function useBrandAssets() {
  return useTenantThemeRuntime().brandAssets;
}
